import React from 'react';
import { Helmet } from 'react-helmet-async';
import Navigation from '../components/Navigation';
import HeroSection from '../components/HeroSection';
import AsSeenOnSection from '../components/AsSeenOnSection';
import MeetMazenSection from '../components/MeetMazenSection';
import ServicesSection from '../components/ServicesSection';
import TestimonialsSection from '../components/TestimonialsSection';
import ContactCTASection from '../components/ContactCTASection';
import ServiceAreasSection from '../components/ServiceAreasSection';
import FAQSection from '../components/FAQSection';
import MortgageCalculator from '../components/MortgageCalculator';
import Footer from '../components/Footer';

const HomePage = () => {
  return (
    <div className="min-h-screen">
      <Helmet>
        <title>Mazen El-Majzoub | Top Real Estate Agent in Tacoma, Seattle, Pierce & King County WA</title>
        <meta name="description" content="Mazen El-Majzoub is a top-performing real estate agent in Tacoma, Seattle, Pierce County and King County, Washington. Expert in buying and selling homes. As seen on The American Dream TV. Contact (253) 315-9480." />
      </Helmet>
      <Navigation />
      <HeroSection />
      <AsSeenOnSection />
      <MeetMazenSection />
      <ServicesSection />
      <TestimonialsSection />
      <ServiceAreasSection />
      <MortgageCalculator />
      <FAQSection />
      <ContactCTASection />
      <Footer />
    </div>
  );
};

export default HomePage;
